import FeaturedProfiles from './FeaturedProfiles';
export default FeaturedProfiles;